import { render, staticRenderFns } from "./TodayWrong.vue?vue&type=template&id=5ae702a6&scoped=true"
import script from "./TodayWrong.vue?vue&type=script&lang=js"
export * from "./TodayWrong.vue?vue&type=script&lang=js"
import style0 from "./TodayWrong.vue?vue&type=style&index=0&id=5ae702a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae702a6",
  null
  
)

export default component.exports